'use strict'

class WhatsApp {

    static open(phone, text){
        phone = parseInt(phone);
        if(!/^598|\+598/.test(phone)){
            phone = '598' + phone;
        }
        window.open(`https://api.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(text)}&app_absent=0`, '_blank');
    }
}

export default WhatsApp;